import axios from '@dap/shared-utils/http.js';

export default {
    // 获取自定义模板列表
    getConfigInfo (params = {}) {
        return axios.get('/dapper/api/custom_column/column_presets', {
            params,
        });
    },

    // 新建时获取所有可选列
    getEmptyColumnInfo (params = {}) {
        return axios.get('/dapper/api/custom_column/columns', { params });
    },

    // 编辑时获取模板详情
    getColumnInfo (params = {}) {
        return axios.get('/dapper/api/custom_column/column_preset', { params });
    },

    // 保存模板
    saveColumn (data = {}) {
        return axios.post('/dapper/api/custom_column/column_preset', data, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    // 更新模板
    updateColumn (data = {}) {
        return axios.put('/dapper/api/custom_column/column_preset', data, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    setDefaultColumn (data = {}) {
        return axios.post('/dapper/api/custom_column/set_default', data, {
            headers: { 'Content-Type': 'application/json' },
        });
    },

    deleteColumn (data = {}) {
        return axios.delete('/dapper/api/custom_column/column_preset', {
            headers: { 'Content-Type': 'application/json' },
            data,
        });
    },

    getColumnDescriptionV2 () {
        return axios.get('/dapper/api/custom_column/dict_v2');
    },
};
